import GeneralMachining01 from "../images/showroom/General_Machining/01s.png";
import GeneralMachining02 from "../images/showroom/General_Machining/02s.png";
import GeneralMachining03 from "../images/showroom/General_Machining/03s.png";
import GeneralMachining04 from "../images/showroom/General_Machining/04s.png";
import GeneralMachining05 from "../images/showroom/General_Machining/05s.png";

import Aerospace01 from "../images/showroom/Aerospace/01s.png";
import Aerospace02 from "../images/showroom/Aerospace/02s.png";
import Aerospace03 from "../images/showroom/Aerospace/03s.png";
import Aerospace04 from "../images/showroom/Aerospace/04s.png";
import Aerospace05 from "../images/showroom/Aerospace/05s.png";

import Die_Mold01 from "../images/showroom/Die_Mold/01s.png";
import Die_Mold02 from "../images/showroom/Die_Mold/02s.png";
import Die_Mold03 from "../images/showroom/Die_Mold/03s.png";
import Die_Mold04 from "../images/showroom/Die_Mold/04s.png";
import Die_Mold05 from "../images/showroom/Die_Mold/05s.png";
import Die_Mold06 from "../images/showroom/Die_Mold/06s.png";

import micromachining01 from "../images/showroom/Micromachining/01s.png";
import micromachining02 from "../images/showroom/Micromachining/02s.png";
import micromachining03 from "../images/showroom/Micromachining/03s.png";
import micromachining04 from "../images/showroom/Micromachining/04s.png";
import micromachining05 from "../images/showroom/Micromachining/05s.png";

import Automotive01 from "../images/showroom/Automotive/01s.png";
import Automotive02 from "../images/showroom/Automotive/02s.png";
import Automotive03 from "../images/showroom/Automotive/03s.png";
import Automotive04 from "../images/showroom/Automotive/04s.png";
import Automotive05 from "../images/showroom/Automotive/05s.png";

const showroomConfig = {
        //General Machining
        TEST:{
            ch:
            {   title:'T',
                items:[
                    {subtitle:'複合件',img:GeneralMachining01,introduction:['工件材質: S45C','工件尺寸: Ø95 X 88 mm','特色:','1.圓偏轉度: 8 um','2.尺寸精度: ±0.015 mm']},
                    {subtitle:'可變閥體',img:GeneralMachining02,introduction:['工件材質: A6061','工件尺寸: 105 x 116 x 40mm','特色:','1.孔位置度 0.02mm','2.多軸加工工序合併，提升加工精度']},
                    {subtitle:'複合閥',img:GeneralMachining03,introduction:['工件材質: A6061','工件尺寸: Ø55 X 56 mm','特色:','車銑加工工序合併，減少累積公差，提升加工精度']},
                    {subtitle:'通訊設備零件',img:GeneralMachining04,introduction:['工件材質: A6061','工件尺寸: Ø50 X 20 mm','特色:','1.尺寸精度 ±0.02mm','2.特殊鍍層刀具提升加工效率10%']},
                    {subtitle:'三爪夾頭',img:GeneralMachining05,introduction:['工件材質: A6061','工件尺寸: Ø80 X 62 mm','特色:','1.多軸加工工序合併，提升加工精度','2.位置度 0.02mm']},
                ]
            },
            en:
            {   title:'T',
                items:[
                    {subtitle:'Test part',img:GeneralMachining01,introduction:['Material: S45C','Dimensions: Ø95 X 88 mm','Feature: Runout 8 um']},
                    {subtitle:'Valve',img:GeneralMachining02,introduction:['Material: A6061','Dimensions: 105 x 116 x 40mm','Position: 0.02 mm']},
                    {subtitle:'Valve',img:GeneralMachining03,introduction:['Material: A6061','Dimensions: Ø55 X 56 mm','Feature: process in one']},
                    {subtitle:'Filter Case',img:GeneralMachining04,introduction:['Material: A6061','Dimensions: Ø50 X 20 mm','Dimension: ±0.02 mm']},
                    {subtitle:'Valve',img:GeneralMachining05,introduction:['Material: A6061','Dimensions: Ø80 X 62 mm','Feature: Combine process with 5-axis']},
                ]
            }
        },
        //General Machining
        GeneralMachining:{
            ch:
            {   title:'零件加工',
                items:[
                    {subtitle:'複合件',img:GeneralMachining01,introduction:['工件材質: S45C','工件尺寸: Ø95 X 88 mm','特色:','1. 圓偏轉度: 8 um','2. 尺寸精度: ±0.015 mm']},
                    {subtitle:'可變閥體',img:GeneralMachining02,introduction:['工件材質: A6061','工件尺寸: 105 x 116 x 40 mm','特色:','1. 孔位置度: 0.02 mm','2. 多軸加工工序合併，提升加工精度']},
                    {subtitle:'複合閥',img:GeneralMachining03,introduction:['工件材質: A6061','工件尺寸: Ø55 X 56 mm','特色:','車銑加工工序合併，減少累積公差，提升加工精度']},
                    {subtitle:'通訊設備零件',img:GeneralMachining04,introduction:['工件材質: A6061','工件尺寸: Ø50 X 20 mm','特色:','1. 尺寸精度: ±0.02 mm','2. 特殊鍍層刀具提升加工效率10%']},
                    {subtitle:'三爪夾頭',img:GeneralMachining05,introduction:['工件材質: A6061','工件尺寸: Ø80 X 62 mm','特色:','1. 多軸加工工序合併，提升加工精度','2. 位置度: 0.02 mm']},
                ]
            },
            en:
            {   title:'General Machining',
                items:[
                    {subtitle:'Test part',img:GeneralMachining01,introduction:['Material: S45C','Dimensions: Ø95 X 88 mm','Runout: 8 um','Accuracy ±0.015 mm']},
                    {subtitle:'Valve',img:GeneralMachining02,introduction:['Material: A6061','Dimensions: 105 x 116 x 40 mm','Position: 0.02 mm']},
                    {subtitle:'Valve',img:GeneralMachining03,introduction:['Material: A6061','Dimensions: Ø55 X 56 mm','Feature: process in one']},
                    {subtitle:'Filter Case',img:GeneralMachining04,introduction:['Material: A6061','Dimensions: Ø50 X 20 mm','Dimension: ±0.02 mm']},
                    {subtitle:'Valve',img:GeneralMachining05,introduction:['Material: A6061','Dimensions: Ø80 X 62 mm','Feature: Combine process with 5-axis']},
                ]
            }
        },
        //Aerospace
        Aerospace:{
            ch:
            {   title:'航太產業加工',
                items:[
                    {subtitle:'引擎掛架',img:Aerospace01,introduction:['工件材質: Titanium','工件尺寸: 315 x 255 x 120 mm','特色:','1. 主軸剛性強化高扭力主軸提升加工效率','2. 孔位置度: 0.05 mm']},
                    {subtitle:'結構件',img:Aerospace02,introduction:['工件材質: A6061','工件尺寸: 142 x 128 x 30 mm','特色:','1. 位置度: 0.02 mm','2. 孔同心度: 0.015 mm']},
                    {subtitle:'艙架',img:Aerospace03,introduction:['工件材質: A7075','工件尺寸: 300 x 590 x 35 mm','特色:','刀具採航太鋁件專用鍍層，加工效率提升15%']},
                    {subtitle:'機翼肋',img:Aerospace04,introduction:['工件材質: A7075','工件尺寸: 515 x 230 x 35 mm','特色:','1. 平面度: 0.15 mm','2. 刀具採航太鋁件專用鍍層，加工效率提升15%']},
                    {subtitle:'結構件',img:Aerospace05,introduction:['工件材質: Titanium','工件尺寸: 472 x 350 x 55 mm','特色:','1. 平面度: 0.15 mm','2. 尺寸精度: ±0.02 mm']},
                ]
            },
            en:
            {   title:'Aerospace',
                items:[
                    {subtitle:'Frame',img:Aerospace01,introduction:['Material: Titanium','Dimensions: 315 x 255 x 120 mm','Feature:','Spindle high torque make better machining performance']},
                    {subtitle:'Frame',img:Aerospace02,introduction:['Material: A6061','Dimensions: 142 x 128 x 30 mm','Position: 0.02 mm']},
                    {subtitle:'Frame',img:Aerospace03,introduction:['Material: A7075','Dimensions: 300 x 590 x 35 mm','Feature:','Improve machining performance 15%']},
                    {subtitle:'Rib',img:Aerospace04,introduction:['Material: A7075','Dimensions: 515 x 230 x 35 mm','Flatness: 0.15 mm']},
                    {subtitle:'Structural part',img:Aerospace05,introduction:['Material: Titanium','Dimensions: 472 x 350 x 55 mm','Flatness: 0.15 mm']},
                ]
            }
        },
        //Die & Mold
        DieMold:{
            ch:
            {   title:'模具加工',
                items:[
                    {subtitle:'齒輪模',img:Die_Mold01,introduction:['工件材質: P20','工件尺寸: 70 x 70 x 35 mm','特色:','1. 平緩曲面特徵無表面參差不齊','2. 加工表面細緻 Ra0.5 um']},
                    {subtitle:'離合器蓋模',img:Die_Mold02,introduction:['工件材質: P20','工件尺寸: 220 x 180 x 45 mm','特色:','1. 平緩曲面特徵無表面參差不齊','2. 加工表面細緻 Ra0.5 um']},
                    {subtitle:'燈模',img:Die_Mold03,introduction:['工件材質: P20','工件尺寸: 65 x 65 x 35 mm','特色:','1. 稜線清晰、稜角銳利','2. 加工面細緻、光澤度佳 Ra0.2 um']},
                    {subtitle:'燈模',img:Die_Mold04,introduction:['工件材質: P20','工件尺寸: 180 x 78 x 80 mm','特色:','1. 稜線清晰、稜角銳利','2. 加工面細緻、光澤度佳 Ra0.3 um']},
                    {subtitle:'燈模',img:Die_Mold05,introduction:['工件材質: STAVAX','工件尺寸: 80 x 80 x 40 mm','特色:','1. 曲面輪廓度 0.03 mm','2. 加工面細緻、光澤度佳 Ra0.2 um']},
                    {subtitle:'彎管模',img:Die_Mold06,introduction:['工件材質: NAK80','工件尺寸: 205 x 205 x 75 mm','特色:','1. 稜線清晰、稜角銳利','2. 加工面細緻 Ra0.3 um']},
                ]
            },
            en:
            {   title:'Die & Mold',
                items:[
                    {subtitle:'Gear mold',img:Die_Mold01,introduction:['Material: P20','Dimensions: 70 x 70 x 35 mm','Feature: Smooth surface Ra0.5 um']},
                    {subtitle:'Cover mold',img:Die_Mold02,introduction:['Material: P20','Dimensions: 220 x 180 x 45 mm','Feature: High quality in landing surface']},
                    {subtitle:'Light mold',img:Die_Mold03,introduction:['Material: P20','Dimensions: 65 x 65 x 35 mm','Feature: Clear and sharp ridge']},
                    {subtitle:'Light mold',img:Die_Mold04,introduction:['Material: P20','Dimensions: 180 x 78 x 80 mm','Feature: Optimal acceleration parameter for corner feature']},
                    {subtitle:'Light mold',img:Die_Mold05,introduction:['Material: STAVAX','Dimensions: 80 x 80 x 40 mm','Feature: Smooth surface Ra0.5 um']},
                    {subtitle:'Pipe mold',img:Die_Mold06,introduction:['Material: NAK80','Dimensions: 205 x 205 x 75 mm','Feature: Clear and sharp ridge']}
                ]
            }
        },
        //Micromachining
        Micromachining:{
            ch:
            {   title:'微細加工',
                items:[
                    {subtitle:'燈模',img:micromachining01,introduction:['工件材質: SKD61','工件尺寸: 80 x 80 x 30 mm','特色:','1. 稜線清晰、稜角銳利','2. R0.2 mm微細轉角特徵完整']},
                    {subtitle:'燈模',img:micromachining02,introduction:['工件材質: SKD61','工件尺寸: 85 x 55 x 35 mm','特色:','1. 稜線清晰、稜角銳利','2. R0.2 mm微細轉角特徵完整']},
                    {subtitle:'燈模',img:micromachining03,introduction:['工件材質: SKD61','工件尺寸: 80 x 80 x 30 mm','特色:','1. 稜線清晰、稜角銳利','2. 依照特徵型式(急遽轉折)調整加減速相關參數']},
                    {subtitle:'複合模型',img:micromachining04,introduction:['工件材質: NAK80','工件尺寸: 45 x 35 x 20 mm','特色:','1. 稜線清晰、稜角銳利','2. R0.3 mm微細轉角特徵完整']},
                    {subtitle:'骨板',img:micromachining05,introduction:['工件材質: Titanium','工件尺寸: 95 x 43 x 15 mm','特色:','1. 加工面細緻、光澤度佳 Ra0.5 um ','2. 多軸加工工序合併，提升精度']},
                ]
            },
            en:
            {   title:'Micromachining',
                items:[
                    {subtitle:'Light mold',img:micromachining01,introduction:['Material: SKD61','Dimensions: 80 x 80 x 30 mm','Feature: Clear and sharp ridge']},
                    {subtitle:'Light mold',img:micromachining02,introduction:['Material: SKD61','Dimensions: 85 x 55 x 35 mm','Feature: R0.2 mm micro feature is complete']},
                    {subtitle:'Light mold',img:micromachining03,introduction:['Material: SKD61','Dimensions: 80 x 80 x 30 mm','Feature: Clear and sharp ridge']},
                    {subtitle:'Demo mold',img:micromachining04,introduction:['Material: NAK80','Dimensions: 45x 35 x 20 mm','Feature: Clear and sharp ridge']},
                    {subtitle:'Bone plate',img:micromachining05,introduction:['Material: Titanium','Dimensions:','Feature: Smooth surface Ra0.5 um']},
                ]
            }
        },
        //Automotive
        Automotive:{
            ch:
            {   title:'汽機車產業加工',
                items:[
                    {subtitle:'連結件',img:Automotive01,introduction:['工件材質: A6061','工件尺寸: 180 x 158  x 25 mm','特色:','1. 尺寸精度: ±0.02 mm','2. 加工表面粗糙度: Ra0.5 um']},
                    {subtitle:'機車機身零件',img:Automotive02,introduction:['工件材質: A6061','工件尺寸: 400 x 210  x 95 mm','特色:','1. 尺寸精度: ±0.02 mm','2. 依照特徵型式(急遽轉折)調整加減速相關參數']},
                    {subtitle:'機車機身零件',img:Automotive03,introduction:['工件材質: A6061','工件尺寸: 175 x 165  x 20 mm','特色:','1. 刀具採鑽石特殊鍍層，加工效率提升15%','2. 孔位置度: 0.02 mm']},
                    {subtitle:'離合器蓋',img:Automotive04,introduction:['工件材質: A6061','工件尺寸: 205 x 170  x 65 mm','特色:','1. 位置精度: 0.02 mm','2. 軸向真直度、垂直度: < 7 um']},
                    {subtitle:'連結件',img:Automotive05,introduction:['工件材質: A6061','工件尺寸: 240 x 275  x 85 mm','特色:','1. 同心度: 0.015 mm','2. 圓柱度: 0.01 mm']},
                ]
            },
            en:
            {   title:'Automotive',
                items:[
                    {subtitle:'Connecting part',img:Automotive01,introduction:['Material: A6061','Dimensions: 180 x 158  x 25 mm','Dimension: ±0.02 mm']},
                    {subtitle:'Cover part',img:Automotive02,introduction:['Material: A6061','Dimensions: 400 x 210  x 95 mm','Feature:','Optimal acceleration parameter for corner feature']},
                    {subtitle:'Connecting part',img:Automotive03,introduction:['Material: A6061','Dimensions: 175 x 165  x 20 mm','Feature:','Improve machining performance 15%']},
                    {subtitle:'Cylinder cover',img:Automotive04,introduction:['Material: A6061','Dimensions: 205 x 170  x 65 mm','Feature:','Axial straightness and perpendicularity < 7 um']},
                    {subtitle:'Connecting part',img:Automotive05,introduction:['Material: A6061','Dimensions: 240 x 275  x 85 mm','Concentricity: 0.015 mm']},
                ]
            }
        },
}

export default showroomConfig;